var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.item.id)?_c('v-btn',{staticStyle:{"margin":"10px","color":"white"},attrs:{"color":"red","rounded":"","loading":_vm.loading},on:{"click":function($event){return _vm.deleteSite(_vm.item.id)}}},[_vm._v(" Delete ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }